/* eslint-disable */
<template >
  <div class="big-container">
      <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    <div class="container">
      <h1 class="text-titulo">Contactos</h1>
      <div>
        <div v-for="(value, key) in contacts" :key="key" class="contactos-container">
            <div><span class="key-text"> {{ key }}</span></div>
            <div><span>&rarr;</span></div>
            <div><span> {{ value }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import _axios from '../../plugins/axios';
export default {
    data: () => ({
        overlay: false,
        contacts: null
    }),

  created() {
    this.getContacts();
  },

  methods: {
    async getContacts() {
        try {
            this.overlay = true;
            this.contacts = await _axios.get('/getSoftlineContacts').then((res) => res.data[0]);
        } catch (error) {
            Swal.fire('Informação', 'Ocorreu um erro durante o carregamneto dos contactos', 'info');
        } finally {
            this.overlay = false;
        }
    }

  }
}
</script>

<style scoped>
.big-container {
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(196, 195, 195, 0.5);
}
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  background-color: #fff;
  border: 0.1px solid #c2c2dd;
  padding: 20px;
  font-size: 12px;
  font-family: sans-serif;
}

.text-titulo {
  font-size: 14px;
}

.key-text {
    display: block;
    text-transform: capitalize;
}

.contactos-container {
    display: grid;
    grid-template-columns: 50px 20px 1fr;
    column-gap: 5px;
}
</style>